import Menu from "../menu/menu";
import logo from '../../assets/images/Logo.svg';
import UserProfile from "../user-profile/user-profile";
import { Link } from "react-router-dom";
import { useResponsiveHelper } from "@myinnsworth/hooks/responsiveHelperHook";

export interface ISideNavProps {
    showResponsiveMenu?: boolean;
    closeResponsiveMenu: () => void;
}

export default function SideNav(props: ISideNavProps) {
    const { isResponsive } = useResponsiveHelper();

    const sideNav = () => <nav>
        <div className="nav-header">
            <div className="logo">
                <Link to="/dashboard">
                    <img src={logo} alt="site logo" />
                </Link>
            </div>

            <Menu 
                onNavigateAway={() => {
                    props.closeResponsiveMenu();
                }}
            />
        </div>

        <div className="nav-footer">
            <UserProfile></UserProfile>
        </div>
    </nav>

    return (
        <>
            {(isResponsive && props.showResponsiveMenu) && <div className="side-nav-responsive-container">
                <div className="content">
                    {sideNav()}

                    <button className="nav-close" title="Close" onClick={() => props.closeResponsiveMenu()}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 19L19 1M1 1L19 19" stroke="#53ADAF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>}

            {
                !isResponsive && sideNav()
            }
        </>
    )
}